import { createAction } from '../util';

export const setStaticPage = createAction('SET_STATIC_PAGE');
